import React from "react";

const Check = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

/**
 * Wizard step rail. Every step shows its label at all times. Steps already
 * visited (index <= maxStep, excluding the current one) render as buttons so the
 * user can click back to them; unvisited steps stay non-interactive.
 */
const WizardProgress = ({ steps, current, maxStep = current, onStepClick }) => {
  const last = steps.length - 1;
  return (
    <>
      <div className="cg-wiz-progress">
        {steps.map((s, i) => {
          const clickable = typeof onStepClick === "function" && i <= maxStep && i !== current;
          const cls = `cg-wiz-step ${i === current ? "active" : ""} ${i < current ? "done" : ""} ${clickable ? "clickable" : ""}`;
          const inner = (
            <>
              <span className="cg-wiz-dot">{i < current ? <Check /> : i + 1}</span>
              <span className="cg-wiz-name">{s}</span>
            </>
          );
          return (
            <React.Fragment key={s}>
              {clickable ? (
                <button type="button" className={cls} onClick={() => onStepClick(i)} aria-label={`Go to step ${i + 1}: ${s}`}>
                  {inner}
                </button>
              ) : (
                <div className={cls}>{inner}</div>
              )}
              {i < last && <span className={`cg-wiz-line ${i < current ? "done" : ""}`} />}
            </React.Fragment>
          );
        })}
      </div>
      <div className="cg-wiz-progress-mini">
        <span className="mini-label">Step {current + 1}/{steps.length}</span>
        <span className="mini-track"><span className="mini-fill" style={{ width: `${((current + 1) / steps.length) * 100}%` }} /></span>
        <span className="mini-label">{steps[current]}</span>
      </div>
    </>
  );
};

export default WizardProgress;
